import React from 'react';
import { Button } from '@chakra-ui/react';
import type { ButtonProps } from '@chakra-ui/react';

const CallToAction = (props: ButtonProps) => {
  return <Button width="full" {...props} height="44px" />;
};

export default CallToAction;
